import { Routes } from '@angular/router';
import { authGuard } from './core/_guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./layout-landing/layout-landing.module').then((m) => m.LayoutLandingModule),
  },
  {
    path: 'sales',
    loadChildren: () =>
      import('./layout/layout.module').then((m) => m.LayoutModule),
    canActivate: [authGuard],
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  { path: '**', redirectTo: 'sales' },
];
